<template>
  <ModalComponent
    ref="modal"
    iconLeftBg="#00f2"
    :onPrimaryClick="
      () => {
        manualySubmitForm()
      }
    "
    :onOverlayClick="
      () => {
        onDismissTriggered()
      }
    "
    :onCancelClick="
      () => {
        onDismissTriggered()
      }
    "
    :onBackButtonClick="
      () => {
        onDismissTriggered()
      }
    "
    :primaryButtonLoading="false"
  >
    <template #titleText>
      <div class="max-w-full w-[450px]" :key="'title' + promptId">
        <div v-html="title"></div>
      </div>
    </template>
    <template #subtitleText>
      <div class="max-w-full w-[450px]" :key="'subtitle' + promptId">
        <div v-html="subTitle"></div>
      </div>
    </template>

    <FormComponent
      :key="'form' + promptId"
      class="max-w-full px-4 gap-x-2"
      :class="[
        { hidden: !formFields.length, grid: formFields.length },
        formClasses,
      ]"
      :fields="formFields"
      :onFormSubmited="
        data => {
          onFormSubmited(data)
        }
      "
      :loading="false"
      ref="form"
      rightBgCustomizationClasses="bg-red-400"
    >
      <template #submitButton><div></div> </template>
    </FormComponent>

    <template #primaryButton v-if="successText">
      {{ successText }}
    </template>
    <template #cancelButton v-if="cancelText">
      {{ cancelText }}
    </template>
  </ModalComponent>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from './ModalComponent.vue'
import Events from '@/events/events'
import Commons from '@/shared/utils/commons'
import FormComponent from '../input/FormComponent.vue'

export default defineComponent({
  name: 'PromptModal',
  components: {
    ModalComponent,
    FormComponent,
  },
  props: {
    init: {
      type: Function,
      default: () => {
        console.log('event for init not set')
      },
    },
  },
  data() {
    return {
      title: 'Title',
      subTitle: '???',
      formClasses: 'Title',
      formFields: [],
      successText: 'Ok',
      cancelText: 'Retour',
      canDismiss: true,
      promptId: '',
      eventsIds: [],
    }
  },
  mounted() {
    this.initPromptFunction()
  },
  methods: {
    initPromptFunction() {
      try {
        window.customPrompt = this.prompt
      } catch (error) {
        console.log(error)
      }
      const id = Events.handle(
        'request:customPrompt',
        async ({ responseId, ...data }) => {
          const response = await this.prompt(data)
          Events.dispatch(responseId, response)
        },
      )
      this.eventsIds.push(id)
    },
    async prompt(data) {
      if (this.modalPromptIsVisible()) {
        this.endPrompt(false)
        await new Promise(r => setTimeout(r, 500))
      }
      this.promptId = Date.now()
      this.title = data.title || ''
      this.subTitle = data.subTitle || ''
      this.formClasses = data.formClasses || ''
      this.formFields = data.formFields || []
      this.successText = data.successText || ''
      this.cancelText = data.cancelText || ''
      this.canDismiss = Commons.isEmpty(data.canDismiss)
        ? true
        : !!data.canDismiss
      const promptPromise = new Promise(resolve => {
        this.handleEventEmitted(`promptResponse:${this.promptId}`, resolve)
      })
      this.showModalPrompt()
      return promptPromise
    },
    handleEventEmitted(eventName, callback) {
      document.addEventListener(eventName, event => {
        callback(event.detail)
      })
    },
    dispatchEvent(eventName, data = {}) {
      document.dispatchEvent(
        new CustomEvent(eventName, {
          detail: data,
        }),
      )
    },
    showModalPrompt() {
      this.$refs.modal.show()
    },
    hideModalPrompt() {
      this.$refs.modal.hide()
    },
    modalPromptIsVisible() {
      return this.$refs.modal.isVisible()
    },
    manualySubmitForm() {
      this.$refs.form.submit()
    },
    onFormSubmited(data) {
      this.endPrompt(true, data)
    },
    onDismissTriggered() {
      if (this.canDismiss) this.endPrompt()
      else {
        setTimeout(() => {
          this.showModalPrompt()
        }, 250)
        console.log('cannot dismiss modal')
      }
    },
    endPrompt(promptAccepted, data = {}) {
      this.hideModalPrompt()
      setTimeout(() => {
        this.dispatchEvent(`promptResponse:${this.promptId}`, {
          success: true,
          accepted: promptAccepted,
          data,
        })
        this.promptId = ''
      }, 250)
    },
  },
  computed: {},
})
</script>
